import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

import button from "../../../assets/img/landingPageThree/sectionSeven/button.webp";

function SectionSeven() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div id="map" className={`sectionSeven-bg ${isVisible ? "visible" : ""}`}>
        <div className="sectionSeven">
          <div className="text">
            <h1 className={`${isVisible ? "visible" : ""}`}>
              {t("lp4_cta_title")}
            </h1>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("lp4_cta_text")}
            </p>
          </div>
          <div className={`line ${isVisible ? "visible" : ""}`}></div>
          <a
            className={`${isVisible ? "visible" : ""}`}
            href={"#home"}
            rel="noreferrer"
            reloadDocument
          >
            <img src={button} alt="" />
            <p>{t("lp4_cta_link")}</p>
          </a>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default SectionSeven;
